import { useContext, useEffect } from "react";
import { RootPageCrumbContext } from "./RootPageCrumbContext";

/**
 * Replaces the trail's last crumb — the current page — with a label only the
 * page knows, e.g. the fetched rule's name in place of the route's static
 * "Rule". Pass `null`/`undefined` while the label is still loading; the
 * static fallback shows until it resolves. Cleared automatically on unmount.
 */
export const useRootPageCurrentCrumb = (label: string | null | undefined) => {
  const setCrumb = useContext(RootPageCrumbContext);
  useEffect(() => {
    if (!setCrumb) {
      return;
    }
    setCrumb(label ?? null);
    return () => setCrumb(null);
  }, [setCrumb, label]);
};
